import React from 'react';

export default class WrongNetworkComponent extends React.Component {
  render () {
    return (
      <div className="c-error-component">
        <div className="c-error-component__container">
          <h1>Whoops! You are on the wrong network</h1>
          <h3>Steps to switch to our right network</h3>
          <div className="c-wrong-network__platforms">
            <div className="c-wrong-network__platforms-item">
              <h2>MetaMask</h2>
              <ol>
                <li>Open MetaMask extension in your Browser</li>
                <li>At the top of MetaMask window click on current network</li>
                <li>When dropdown opens click on <strong>Ropsten Test Network</strong></li>
              </ol>
            </div>
            <div className="c-wrong-network__platforms-item">
              <h2>Coinbase Wallet</h2>
              <ol>
                <li>Go to Wallet settings</li>
                <li>Go to Advanced</li>
                <li>Go to Active network</li>
                <li>Select Ropsten Test Network</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/WrongNetworkComponent.js